export function generatePathFromName(nameValue: string): string {
  return nameValue
    .toLowerCase()
    .trim()
    .replaceAll(/[^\s\w]/gi, '')
    .replaceAll(/\s+/g, '-')
    .slice(0, 32)
}
